import { Component } from '@angular/core';
import { LoginService } from '../../../services/login-0/login-0.service';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'], // Corrected: `styleUrl` -> `styleUrls`
})
export class TabsComponent {
  botones: any[] = [
    { nombre: 'Panel principal', id: '1', url: '/dashboard', img:'../../../../assets/icons/monitor.svg'},
    { nombre: 'Equipos', id: '1', url: '/equipos', img:'../../../../assets/icons/people.svg'},
    { nombre: 'Compras', id: '2', url: '/compras', img:'../../../../assets/icons/cart.svg' },
    { nombre: 'Registros', id: '3', url: '/registros', img:'../../../../assets/icons/document-text.svg'},
    { nombre: 'Billetera', id: '4', url: '/wallet', img:'../../../../assets/icons/card.svg'},
  ];

  constructor(private navController: NavController, private loginService: LoginService) {}

  ngOnInit() {}

  redirectPage(page: string, animated: boolean = true) {
    this.navController.navigateRoot(page, { animated });
  }

  logout(): void {
    this.loginService.logout();
  }
}
